import gql from 'graphql-tag';

export default gql`
  mutation DesktopInstanceDownloadFile($fileName: String!, $instanceId: String!, $src: String!) {
    desktopInstanceDownloadFile(fileName: $fileName, instanceId: $instanceId, src: $src) {
      id
    }
  }
`;
